import {ChangeDetectionStrategy, Component, inject, input, output} from "@angular/core";
import {bzIconSettings} from "@bringoz/ui/icons";
import * as _ from "lodash";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {ThreePLServicesSettings} from "../../models/threepl-services-list.model";
import {servicesTableColumns} from "../../../../deliveries/constants/services-table-columns.const";
import {
  ThreeplServicesSettingsPanelContentComponent, ThreePLServicesSettingsPanelData,
} from "../threepl-services-settings-panel-content/threepl-services-settings-panel-content.component";

@Component({
  selector: "app-threepl-services-settings-panel",
  templateUrl: "./threepl-services-settings-panel.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServicesSettingsPanelComponent {
  readonly settings = input.required<ThreePLServicesSettings>();
  readonly settingsChange = output<ThreePLServicesSettings>();

  readonly icon = bzIconSettings;

  private readonly panelService = inject(PanelService);

  onOpen(event: MouseEvent): void {
    const settings = this.settings();
    const data: ThreePLServicesSettingsPanelData = {
      defaultGroup: settings.defaultGroup,
      columns: _.cloneDeep(settings.columns),
      dynamicColumns: _.cloneDeep(settings.dynamicColumns),
      columnSizes: settings.columnSizes,
      columnOrder: settings.columnOrder,
      resetColumns: servicesTableColumns,
    };
    const panel = this.panelService.open(ThreeplServicesSettingsPanelContentComponent, event, data, {
      position: {originX: "start", originY: "bottom", overlayX: "start", overlayY: "top"},
    });
    panel?.afterClose$.subscribe((result: ThreePLServicesSettings | undefined | null) => {
      if (result) {
        this.settingsChange.emit(result);
      }
    });
  }
}
